import React from "react";

import moment from "moment";
import Loading from "ui/Loading";
import IndexSelectionResults from "features/IndexAdvisor/IndexSelectionResults";
// eslint-disable-next-line no-restricted-imports -- pre-existing cross-feature deep import
import { transformIndexSelectionResult } from "features/Schema/SchemaTableIndexAdvisor/util";

import { IssueDetailQuery } from "../gql/Query.generated";

type IssueType = IssueDetailQuery["getIssue"];
type IssueReferenceTable = Extract<
  IssueType["references"][number]["referent"],
  { __typename?: "SchemaTable" }
>;

import { useIndexingEngineIssueQuery } from "./gql/Query.generated";

const IndexAdvisorIndexingEngine: React.FunctionComponent<{
  issue: IssueType;
}> = ({ issue }) => {
  const detail = issue.details;
  const runId = detail.indexing_engine_run;
  // Work around https://github.com/pganalyze/pganalyze/issues/3674 by
  // hiding deletion suggestions unless using a custom config (presets
  // never include consolidation).
  const useConsolidation = detail.index_advisor_settings_name == "custom";

  const table = issue.references.find((ref) => ref.kind === "SchemaTable")
    .referent as IssueReferenceTable;

  const { data, loading, error } = useIndexingEngineIssueQuery({
    variables: { runId, databaseId: issue.databaseId, tableId: table.id },
  });

  if (loading || error) {
    return <Loading error={!!error} />;
  }

  const result = transformIndexSelectionResult(
    data,
    moment.unix(data.getSchemaTableIndexSelection.runAt),
  );

  return (
    <IndexSelectionResults
      databaseId={issue.databaseId}
      result={result}
      useConsolidation={useConsolidation}
    />
  );
};

export default IndexAdvisorIndexingEngine;
